import type { ShipmentExceptionRow } from '@gpx-spa/queries/src/shipment-exception-types';

/** Open exceptions that name this tracker (ENG-2814). */
export function openExceptionsForDevice(
  exceptions: readonly ShipmentExceptionRow[],
  deviceId: number,
): ShipmentExceptionRow[] {
  if (!deviceId) return [];
  return exceptions.filter(
    (row) => row.status === 'open' && (row.device_ids ?? []).includes(deviceId),
  );
}
